import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {CheckBox, HelperIconInfo} from "../../../../index";
import {t} from 'ttag';
import {Box, Typography, useMediaQuery, useTheme} from "@material-ui/core";
import {setSwBookState} from "../../../../../store/reducers/search-widget";

const BookWithCashNMilesCheckboxConnected = () => {

    const withCashNMiles = useSelector(state => state.sw.book.withCashNMiles);
    const withMiles = useSelector(state => state.sw.book.withMiles);
    const promoCode = useSelector(state => state.sw.book.promoCode);
    const dispatch = useDispatch();

    const {breakpoints} = useTheme();
    const isLowerThenSmall = useMediaQuery(breakpoints.down('xs'));

    return (
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
            <CheckBox
                label={<Typography variant={isLowerThenSmall ? 'caption' : undefined}>{t`Cash&miles`}</Typography>}
                checked={Boolean(withCashNMiles)}
                onChange={e => dispatch(setSwBookState({withCashNMiles: e.target.checked}))}
                disabled={Boolean(withMiles || promoCode)}
            />
            <HelperIconInfo
                title={t`Use miles for the full or partial purchase of a ticket`}
                subtitle={t`Available on payment page`}
                placement={'left'}
            />
        </Box>
    );
};

export default BookWithCashNMilesCheckboxConnected;
